module.exports = __webpack_public_path__ + "img/company.79c0eee9.png";